import React from 'react';
import { DateTime } from 'luxon';
import { Fieldset, Input } from '@flixbus/honeycomb-react';

import { useVoucherFormContext } from '../../../Context';
import { Asterisk } from '../../../Asterisk';

import { toISODate } from '../../../../../helpers/dateTime';

const VoucherFormValidSince: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  const {
    formState: {
      payload: { validSince },
    },
    handlePayloadChange,
  } = useVoucherFormContext();

  const dateObject = validSince ? DateTime.fromISO(validSince) : null;

  return (
    <Fieldset itemSpacing='half'>
      <Input
        name='date-field-validSince'
        id='date-field-validSince'
        label={<>Voucher valid from {!disabled && <Asterisk />}</>}
        type='date'
        min={new Date().toString()}
        disabled={disabled}
        required
        value={dateObject ? dateObject.setLocale('de').toFormat('yyyy-MM-dd') : ''}
        onChange={e => {
          const { value } = e.target;

          if (value === '') {
            const date = new Date();
            handlePayloadChange({
              value: toISODate(DateTime.fromJSDate(date)),
              prop: 'validSince',
            });
          } else {
            const date = new Date(value);
            handlePayloadChange({
              value: toISODate(DateTime.fromJSDate(date)),
              prop: 'validSince',
            });
          }
        }}
      />
    </Fieldset>
  );
};

export default VoucherFormValidSince;
